module.exports = __webpack_public_path__ + "images/file_icons_v2/txt-c973965faebeed203450fcd33cc3e812.svg";